function getClickToContinueObj() {
  const returnObj = {
    onClick: undefined,
    promise: undefined,
  };

  returnObj.promise = new Promise((resolve, reject) => {
    returnObj.onClick = () => resolve();
  });

  return returnObj;
}

const clickToContinueContainer = {
  current: undefined,
};

function resetClickToContinue() {
  clickToContinueContainer.current = getClickToContinueObj();
}

export { clickToContinueContainer, resetClickToContinue };



// WEBPACK FOOTER //
// ./utils/clickToContinueUtils.js